module.exports = __webpack_public_path__ + "img/finland-colorectal-cancer-female.c62173b6.png";